export const MAIN_CONTENT_ASSUMPTION_SET = {
  MIN_WIDTH: 1650,
  PADDING: 3,
} as const

export const MAIN_CONTENT_DIAGNOSIS = {
  MIN_WIDTH: 1650,
  PADDING: 3,
} as const

export const MAIN_CONTENT_PIVOTED_ASSUMPTION_SET = {
  MIN_WIDTH: 1650,
  PADDING: 3,
} as const

export const DRAG_BAR = {
  PADDING: 2,
  WIDTH: 6,
} as const

export const RESIZABLE_GRID = {
  WRAPPER: {
    display: 'flex',
    flexGrow: 1,
    userSelect: 'none',
  },
  BOX: {
    overflow: 'hidden',
    minWidth: 40,
    minHeight: 40,
    userSelect: 'text',
    flexShrink: 0,
    transition: 'filter 0.2s ease-out, background-color 0.2s ease-out',
  },
  PASSIVE_BOX: {
    overflow: 'hidden',
    minWidth: 40,
    minHeight: 40,
    userSelect: 'text',
    flexGrow: 1,
    transition: 'filter 0.2s ease-out, background-color 0.2s ease-out',
  },
  DRAG_BAR: {
    tabIndex: 0,
    flexShrink: 0,
    transition: 'background-color 0.15s 0.15s ease-in-out',
  },
} as const

export const VARIABLE_EDITOR = {
  header: {
    height: 32,
    padding: 2,
    get paddingSizeY() {
      return this.padding * CHAKRA_UI_MODIFIER * 2
    },
  },
  defaultHeight: 550,
  defaultWidth: 500,
  scrollBar: {
    width: 15,
  },
  body: {
    padding: 2,
    borderY: 1,
    get paddingSizeX() {
      return this.padding * CHAKRA_UI_MODIFIER * 2
    },
    get paddingSizeY() {
      return this.padding * CHAKRA_UI_MODIFIER * 2
    },
    get borderSizeY() {
      return this.borderY * 2
    },
  },
  container: {
    paddingBottom: 3,
    border: 1,
    get paddingSizeY() {
      return this.paddingBottom * CHAKRA_UI_MODIFIER
    },
    get borderSizeY() {
      return this.border * 2
    },
    get borderSizeX() {
      return this.border * 2
    },
  },
  get emptyEditorHeight() {
    return (
      this.container.paddingSizeY +
      this.container.borderSizeY +
      this.header.height +
      this.header.paddingSizeY +
      this.body.paddingSizeY +
      this.body.borderSizeY
    )
  },
  get additionalSpacesNextToContent() {
    return (
      this.body.paddingSizeX + this.container.borderSizeX + this.scrollBar.width
    )
  },
}

export const CHAKRA_UI_MODIFIER = 4

export const Z_INDEX = {
  contextMenu: 1200,
  nonModalDialogBase: 1000,
  get informationDialog() {
    return this.nonModalDialogBase + 1
  },
  multiSelect: 1,
  get multiSelectFilterDialog() {
    return this.nonModalDialogBase + 3
  },
  get selectPopover() {
    return this.nonModalDialogBase + 2
  },
  simpleTable: 1,
} as const

// Conservative upper bound on the AppBar's rendered height. The bar has
// `flexWrap: "wrap"` so it can grow, but 64px covers the unwrapped case
// (padding + icon button). Used to keep non-modal dialogs below the
// AppBar when their initial position is auto-adjusted to fit the viewport.
export const APP_BAR_HEIGHT = 64

export const CONTEXT_MENU = {
  content: {
    zIndex: Z_INDEX.contextMenu,
    backgroundColor: '#FFF',
    border: '1px solid',
    borderRadius: '10px',
    borderColor: '#666',
    minWidth: '140px',
    padding: '5px',
    paddingLeft: '5px',
    paddingRight: '5px',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontSize: '12px',
    fontWeight: '600',
    userSelect: 'none',
  },
} as const
